<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->
<mat-toolbar class="toolbar" [style.backgroundColor]="'var(--crucible-topbar-background)'"
  [style.color]="'var(--crucible-topbar-text)'"
  >
  <mat-toolbar-row>
    <span class="margin-auto">
      <a mat-icon-button class="home-logo" aria-label="Steamfitter home" [routerLink]="['/']" title="Home">
        <mat-icon svgIcon="ic_crucible_steamfitter"></mat-icon>
      </a>
    </span>
    <span class="view-text">{{ title }}</span>
    <span class="spacer"></span>
    @if (currentUser$ | async; as currentUser) {
      <div
        class="user-text"
        >
        <button
          mat-button
          class="menu-trigger"
          [matMenuTriggerFor]="menu"
          style="outline: none"
          >
          <strong>{{ currentUser.name }}</strong>
          <mat-icon class="menu-trigger" fontIcon="mdi-chevron-down"></mat-icon>
        </button>
        <mat-menu #menu="matMenu" [overlapTrigger]="false">
          @if (topbarView === TopbarView.STEAMFITTER_ADMIN) {
            <button
              [routerLink]="['/']"
              mat-menu-item
              >
              Exit Administration
            </button>
          }
          @if (canViewAdmin && topbarView !== TopbarView.STEAMFITTER_ADMIN) {
            <button
              [routerLink]="['/admin']"
              mat-menu-item
              >
              Administration
            </button>
          }
          <button mat-menu-item (click)="logout()">Logout</button>
          <mat-slide-toggle
            aria-labelledby="theme-toggle"
            class="mat-menu-item"
            color="primary"
            [checked]="(theme$ | async) === 'dark-theme' ? true : false"
            (click)="$event.stopPropagation()"
            (change)="themeFn($event)"
            >
            <mat-label id="theme-toggle">Dark Theme</mat-label>
          </mat-slide-toggle>
        </mat-menu>
      </div>
    }
  </mat-toolbar-row>
</mat-toolbar>
